import localeCodes from "locale-codes";

export const languageToi18nCode = (language: string) => {
	return localeCodes.getByName(language)?.tag;
};
